import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertBoxComponent {

  @Input() title?: string;
  @Input() message: string;
  @Input() storageKey: string;
  @Input() translateTitle = true;
  @Input() translateMessage = true;
  @Input() iconSrc = '/assets/images/8dec87856bf3d8f8e8e05073b444f02ec99291a1df739330ce862a09fd387e92.svg';
  @Input() closeIconSrc = '/assets/images/350ca7c321a1a2607e52460b1edfd0452e92de6e86d4d57567d428b1bd8b3f96.svg';

  get visible(): boolean {
    if (this.storageKey) {
      return localStorage.getItem(this.storageKey) !== 'hidden';
    }
    return true;
  }

  close(): void {
    if (this.storageKey) {
      localStorage.setItem(this.storageKey, 'hidden');
    }
  }
}
